import React from "react";
import PropTypes from "prop-types";

import { Icon } from ".";
import { useTrans, useFeatureFlags } from "../hooks";
import { PREMIUM_PICKS_LIVENESS } from "../constants";

export const PremiumPicksProps = {
  liveness: PropTypes.oneOf(Object.values(PREMIUM_PICKS_LIVENESS)),
  endsAt: PropTypes.object,
  startsAt: PropTypes.object
};

/**
 * The report story card.
 */
const PremiumPicksCard = ({ isCurrentPick, isUpcomingPick, premiumPicks }) => {
  const { trans } = useTrans();
  const featureflags = useFeatureFlags();

  if (
    !featureflags.ROTATING_CATALOG_PHASE_3 &&
    !isCurrentPick &&
    !isUpcomingPick
  )
    return null;

  if (featureflags.ROTATING_CATALOG_PHASE_3 && !premiumPicks) return null;

  let cardDate;

  if (featureflags.ROTATING_CATALOG_PHASE_3) {
    cardDate =
      premiumPicks.liveness == PREMIUM_PICKS_LIVENESS.NOW
        ? premiumPicks.endsAt
        : premiumPicks.startsAt;
  } else {
    cardDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      1,
      0,
      0,
      0,
      0
    );

    if (isCurrentPick) {
      cardDate.setDate(cardDate.getDate() - 1);
    }
  }

  return (
    <div>
      <a className="card on-navigate" href="/catalog/premiumpicks" tabIndex="0">
        <div className="card__action-icon-premium-content">
          <Icon
            name="zap"
            size="12"
            className="card__action-icon"
            color={
              featureflags.ROTATING_CATALOG_PHASE_3
                ? "ds-neutral-00-solid"
                : "ds-base-4-accent"
            }
            fill
          />
        </div>
        <div className="card__label column">
          <span id="content-title" className="card__title">
            {trans("Premium Picks")}
          </span>
          <div className="card__description md">
            {isCurrentPick ||
            (featureflags.ROTATING_CATALOG_PHASE_3 &&
              premiumPicks.liveness == PREMIUM_PICKS_LIVENESS.NOW)
              ? trans("Free for subscribers until")
              : trans("Free for subscribers on")}{" "}
            {cardDate.toLocaleString("default", {
              month: "short",
              day: "numeric"
            })}
          </div>
        </div>
        <Icon className="card__nav-icon" name="chevRight" size="24" />
      </a>
    </div>
  );
};

PremiumPicksCard.propTypes = {
  isCurrentPick: PropTypes.bool,
  isUpcomingPick: PropTypes.bool,
  premiumPicks: PropTypes.shape(PremiumPicksProps)
};

export default PremiumPicksCard;
